/*
 * PEWNA lifestyle carousel — scroll-by-tile on arrow click.
 * Native scroll + scroll-snap handles touch; the arrows are progressive
 * enhancement for desktop pointer users.
 */
class PewnaLifestyleCarousel extends HTMLElement {
  constructor() {
    super();
    this.scroller = this.querySelector('[data-scroller]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');

    this.handlePrev = this.handlePrev.bind(this);
    this.handleNext = this.handleNext.bind(this);
  }

  connectedCallback() {
    this.prevBtn?.addEventListener('click', this.handlePrev);
    this.nextBtn?.addEventListener('click', this.handleNext);
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this.handlePrev);
    this.nextBtn?.removeEventListener('click', this.handleNext);
  }

  scrollByTile(direction) {
    if (!this.scroller) return;
    const firstTile = this.scroller.firstElementChild;
    const tileWidth = firstTile ? firstTile.getBoundingClientRect().width : 300;
    const gap = parseFloat(getComputedStyle(this.scroller).columnGap || '16') || 16;
    this.scroller.scrollBy({
      left: direction * (tileWidth + gap),
      behavior: 'smooth',
    });
  }

  handlePrev() { this.scrollByTile(-1); }
  handleNext() { this.scrollByTile(1); }
}

customElements.define('pewna-lifestyle-carousel', PewnaLifestyleCarousel);
